import clsx from 'clsx';
import React from 'react';

export interface PlatformOption {
  value: string;
  label: string;
  disabled?: boolean;
  helperText?: React.ReactNode;
}

export interface PlatformSelectCardsProps {
  options: PlatformOption[];
  selected: string[];
  onToggle: (value: string) => void;
  /** Wrapper class; content uses space-y-3 by default (padding comes from ModalLayout) */
  className?: string;
}

/**
 * App Screens Upload ve Metadata Export/Translation ile aynı platform seçim kartları.
 * Her seçenek: border, padding, checkbox + label; isteğe bağlı disabled ve helper metin.
 */
const PlatformSelectCards: React.FC<PlatformSelectCardsProps> = ({
  options,
  selected,
  onToggle,
  className,
}) => {
  return (
    <div className={clsx('space-y-3', className)}>
      {options.map(opt => {
        const isSelected = selected.includes(opt.value);
        const isDisabled = opt.disabled;
        return (
          <label
            key={opt.value}
            className={clsx(
              'flex flex-col gap-1.5 p-3 rounded-lg border transition-colors',
              isDisabled
                ? 'border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-800/50 opacity-80'
                : 'border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700/50 cursor-pointer'
            )}
          >
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => !isDisabled && onToggle(opt.value)}
                disabled={isDisabled}
                className="rounded border-gray-300 dark:border-gray-600 text-primary-600 focus:ring-primary-500 disabled:opacity-50"
              />
              <span className="text-sm font-medium text-gray-900 dark:text-white">
                {opt.label}
              </span>
            </div>
            {opt.helperText && (
              <div className="text-xs text-gray-500 dark:text-gray-400 pl-6">
                {opt.helperText}
              </div>
            )}
          </label>
        );
      })}
    </div>
  );
};

export default PlatformSelectCards;
